<template>
    <div class="page home-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="settingsData">
                    <v-card flat class="bordered px-lg-2 mb-6">
                        
                        <v-card-title class="mb-1 medium-title">
                            <!-- <v-icon color="primary" size="24" class="me-1">mdi-facebook</v-icon> -->
                            <span>إعدادات المظهر والواجهة</span>
                        </v-card-title>
                        <v-card-subtitle class="details-text px-5">تهيئة المظهر وإعدادات واجهة المتجر الخاص بك</v-card-subtitle>
                        <v-divider class="mx-5 my-1"></v-divider>
                        <v-card-text class="py-3">
                            <v-list class="pa-0 transparent ma-0" max-width="700">
                                <settings-item flat nullable :data="settingsData" name="theme" ltr select icon="mdi-view-dashboard-variant-outline" color="strong-text" title="القالب (Theme)" :select-items="themes" subtitle="" @sync="sync" >
                                    <template slot="body-top">
                                        <v-alert v-if="subscription === 'free' && allowBillsPage" type="info" text color="orange darken-2" icon="mdi-crown-circle">
                                            <div class="details-text strong-text--text">
                                                يجب الاشتراك في الخطة المميزة لتحصل على القوالب المدفوعة
                                            </div>
                                        </v-alert>
                                    </template>
                                </settings-item>
                                <settings-item flat nullable :data="settingsData" name="primary_color" ltr is-color-picker icon="mdi-palette" :color="settingsData.primary_color" title="اللون الأساسي" subtitle="اللون الأساسي للهوية البصرية الخاصة بالمتجر" @sync="sync"/>
                            </v-list>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="subscription === 'advanced'" flat class="bordered px-lg-2 mb-6">
                        
                        <v-card-title class="mb-1 medium-title">
                            <!-- <v-icon color="primary" size="24" class="me-1">mdi-facebook</v-icon> -->
                            <span>شريط الإعلان</span>
                        </v-card-title>
                        <v-card-subtitle class="details-text px-5">شريط علوي يمكنك استخدامه للإعلان عن شيء بشكل مُلفت</v-card-subtitle>
                        <v-divider class="mx-5 my-1"></v-divider>
                        <v-card-text class="py-3">
                            <v-list class="pa-0 transparent ma-0" max-width="700">
                                <settings-item flat is-textarea nullable :data="settingsData" name="announcement_text" icon="mdi-bullhorn-outline" color="strong-text" title="نص الشريط الإعلاني" subtitle="النص الذي يظهر على الشريط الإعلاني (لإخفاء الشريط اتركه فارغاً)" @sync="sync"/>
                                <settings-item flat nullable :data="settingsData" name="announcement_background_color" ltr is-color-picker icon="mdi-palette" :color="settingsData.announcement_background_color || settingsData.primary_color" title="لون الخلفية" subtitle="لون خلفية شريط الإعلان" @sync="sync"/>
                                <settings-item flat nullable :data="settingsData" name="announcement_text_color" ltr is-color-picker icon="mdi-palette" color="strong-text" title="لون النص" subtitle="لون الكتابة في شريط الإعلان" @sync="sync"/>
                            </v-list>
                        </v-card-text>
                    </v-card>

                    <v-card flat class="bordered px-lg-2 mb-6">
                        <v-card-title class="mb-1 medium-title">
                            <!-- <v-icon color="primary" size="24" class="me-1">mdi-facebook</v-icon> -->
                            <span>السلايدر العلوي في المتجر</span>
                        </v-card-title>
                        <v-card-subtitle class="details-text px-5">تعديل الصور التي تظهر في السلايدر العلوي المتحرك في واجهة المتجر</v-card-subtitle>
                        <v-divider class="mx-5 my-1"></v-divider>
                        <v-card-text>

                            <div>
                                <div class="d-flex flex-wrap w-100">
                                    <div v-for="(image, i) in slideImages" :key="i" class="ma-1">
                                        <v-img cover center :src="image.url" width="114" height="105" style="border-radius: 4px" class="slide-image bordered">
                                            <div class="image-actions" style="position: absolute; top: 5px; left: 5px;">
                                                <v-btn icon small color="red" @click="openDeleteImageDialog(image)">
                                                    <!-- <v-icon size="20">mdi-dots-vertical</v-icon> -->
                                                    <v-icon size="19">mdi-delete</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-img>
                                    </div>
                                    <div>
                                        <transition name="fade-transition" appear>
                                            <v-img width="114" height="105" class="add-image d-flex align-center ma-1" @click="openImageUpload">
                                                <div class="text-center">
                                                    <v-icon color="grey" class="mx-auto">mdi-image-plus</v-icon>
                                                </div>
                                            </v-img>
                                        </transition>
                                    </div>
                                </div>
                                <!-- <v-btn block color="primary" text @click="openImageUpload">
                                    <v-icon left>mdi-image-plus</v-icon>
                                    <span>إضافة صور جديدة</span>
                                </v-btn> -->
                            </div>
                            <input ref="imageInput" type="file" @change="handleImageUpload" accept="image/*" hidden />

                        </v-card-text>
                    </v-card>
                </div>
            </transition>

            <action-dialog v-model="deleteImageDialog" vuex-action="deleteSlideImage" :title="`حذف الصورة`" :data="{id: deleteImage ? deleteImage.id : null}" button-text="تأكيد الحذف" button-color="error" @sync="sync" @reset="deleteImage = null;">
                هل أنت متأكد من حذف الصورة؟
            </action-dialog>
      </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import SettingsItem from '@/components/default/settings-item'


export default {
    name: "ThemeSettings",
    components: {
        SettingsItem,
    },
    data(){
        return {
            loading: false,
            availableThemes: null,

            uploadingImage: false,

            deleteImage: null,
            deleteImageDialog: false,
        }
    },
    computed: {
        ...GlobalComputed,
        settingsData(){
            return this.$store.state.storeModule.settings;
        },
        allowBillsPage(){
            return this.platform !== 'ios' || this.appData.ios_show_bpage;
        },
        slideImages(){
            return this.$store.state.storeModule.slideImages;
        },
        themes(){
            let themes = [
                {text: 'قالب افتراضي', value: 'default', color: 'muted', icon: 'mdi-view-dashboard-variant-outline'},
            ];
            if (this.allowBillsPage){
                themes.push(...[
                    {text: 'قالب مميز 1', value: 'premium1', color: 'orange darken-2', icon: 'mdi-crown-circle'},
                    {text: 'قالب مميز 2', value: 'premium2', color: 'orange darken-2', icon: 'mdi-crown-circle'},
                ]);
            }
            return themes.map(theme=>{
                if (this.availableThemes && !this.availableThemes.includes(theme.value)){
                    theme.disabled = true;
                }else{
                    theme.disabled = false;
                }
                return theme;
            });
        }

    },
    methods: {
        ...GlobalMethods,
        openDeleteImageDialog(image){
            this.deleteImage = image;
            this.deleteImageDialog = true;
        },
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getStoreSettings').then(response=>{
                    this.loading = false;
                    this.availableThemes = response.data.available_themes;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات', 'error');
                })
            }
        },
        sync(data){
            this.$store.commit('UPDATE_STORE_SETTINGS', data);
        },

        openImageUpload(){
            this.$refs.imageInput.value = '';
            this.$refs.imageInput.click();
        },
        handleImageUpload(event){
            let files = event.target.files;
            if (files && files.length){
                this.uploadNewImage(files[0]);
            }
        },
        uploadNewImage(image){
            let formData = new FormData();
            formData.append('image', image);
            
            if (!this.uploadingImage){
                this.uploadingImage = true;
                this.$store.dispatch('uploadSlideImage', {data: formData, headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
                    
                    this.showMsg('تمت إضافة الصورة بنجاح', 'success');
                    this.uploadingImage = false;
                    this.sync(response.data.data);
                }).catch(()=>{
                    this.uploadingImage = false;
                    this.showMsg('حدثت مشكلة أثناء الرفع', 'error');
                });
            }
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        updatingLogo(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>

<style lang="scss" scoped>
.slide-image{
    .image-actions{
        opacity: 0;
        transition: 0.2s ease all;
    }
    &:hover{
        .image-actions{
            opacity: 1;
        }
    }
}
.add-image{
    border-radius: 4px;
    border: 2px dashed rgba(0,0,0, .1)!important;
    cursor: pointer;
    transition: 80ms ease-out all;

    &:hover{
        border-color: rgba(0,0,0, .3)!important;
    }
    &:active{
        transform: scale(0.97);
    }
}
</style>